var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckcircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10104_105342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.23843V10.0051C18.3323 11.8021 17.7504 13.5507 16.6745 14.99C15.5985 16.4292 14.0861 17.4822 12.3628 17.9917C10.6395 18.5012 8.79772 18.44 7.11206 17.8172C5.42641 17.1945 3.98722 16.0435 3.00914 14.536C2.03106 13.0285 1.5665 11.2451 1.68474 9.45202C1.80297 7.6589 2.49768 5.95203 3.66524 4.58599C4.8328 3.21994 6.41066 2.26791 8.1635 1.87188C9.91633 1.47585 11.7502 1.65704 13.3917 2.38843M18.3333 3.33366L10 11.6753L7.50001 9.17533",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10104_105342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircle);
export default __webpack_public_path__ + "static/media/checkcircle.9e45d6dd9e6f17f6c373ad707629834f.svg";
export { ForwardRef as ReactComponent };